import React from "react"
import classnames from "classnames"
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap"
import { logW } from "src/core/helpers/log"
import { isFunction, objHasKey } from "src/core/helpers/utils"
import MyForm from "src/core/components/MyForm/MyForm"
import { MyUI, MyLoading, MyPage } from "@macashipo/mlib"
import { kfnGetIsInModal } from "src/helpers/fnList"
interface IProps {
  className?: any
  style?: any
  type: string
}

interface IState {
  isShow?: boolean
  opts?: IConfigModal
  showLoading?: boolean
}

interface IConfigModal {
  component?: any
  showFooter?: boolean
  showHeader?: boolean
  modalClassName?: string
  modalCentered?: boolean
  modalScrollInside?: boolean
  title?: string
  usingModalBody?: boolean
  size?: string
  backdrop?: any | "static"
  fnList?: any
  msg?: any
  msgHtml?: any
  classNameBody?: string
  onClickClose?: any
  onClickOK?: any
  showFooterClose?: boolean
  showFooterOK?: boolean
  titleBtnOK?: string
  colorBtnOK?: string
  configMyPage?: any
  wrapComponentBody?: any //wrap component thay the modalBody, khi usingModalBody = false
}

class MyModal extends React.Component<IProps, IState> {
  state: any = {
    isShow: false,
    showLoading: false,
    opts: {},
  }
  _fnList: any = {}
  componentDidMount() {
    const { type } = this.props
    MyModal.Helpers.initComponent(type, this)
    this._fnList = {
      [kfnGetIsInModal]: () => {
        return true
      },
      getModal: () => {
        return this
      },
      hideModal: () => {
        this.hide()
      },
      showLoadingModal: v => {
        this.showLoading(v)
      },
      hideLoadingModal: () => {
        this.hideLoading()
      },
    }
  }
  show = (opts: any) => {
    this.setState({
      isShow: true,
      opts: { ...MyModal.Helpers.defaultConfigModal, ...opts },
    })
  }
  showLoading = (v = true) => {
    this.setState({
      showLoading: v,
    })
  }
  hideLoading = () => {
    this.setState({
      showLoading: false,
    })
  }
  hide = () => {
    this.setState({
      isShow: false,
      showLoading: false,
      opts: {},
    })
  }
  toggle = () => {
    this.setState({
      isShow: !this.state.isShow,
    })
  }
  _getConfig = key => {
    const { opts } = this.state
    if (objHasKey(opts, key)) {
      return opts[key]
    }
  }
  _renderContent = () => {
    let _ui = null
    const { type } = this.props
    const { opts, isShow } = this.state
    if (isShow !== true) {
      return <div></div>
    }
    switch (type) {
      case MyModal.Helpers.types.myui:
        return <MyUI {...opts?.configMyUI} />
      case MyModal.Helpers.types.mydialog:
        if (opts.component) {
          if (isFunction(opts.component)) {
            return opts.component({
              inMyModal: this,
              fnList: { ...this._fnList, ...opts.fnList },
              configFromModal: opts,
            })
          } else {
            return opts.component
          }
        } else {
          if (opts.msgHtml) {
            return <MyUI type="html" html={opts.msgHtml} />
          } else if (opts.msg) {
            return opts.msg
          }
          return ""
        }
      case MyModal.Helpers.types.component:
        if (opts.component) {
          if (isFunction(opts.component)) {
            return opts.component({
              inMyModal: this,
              fnList: { ...this._fnList, ...opts.fnList },
              configFromModal: opts,
            })
          } else {
            return opts.component
          }
        } else {
          logW("Missing component")
          return <div></div>
        }
      case MyModal.Helpers.types.mypage:
        return (
          <MyPage
            configPage={opts?.configMyPage}
            fnList={{
              ...this._fnList,
              ...opts.fnList,
              ...opts.configMyPage.fnList,
            }}
          />
        )
      case MyModal.Helpers.types.cellinmodal:
        return <MyUI {...opts?.configMyUI} />
      case MyModal.Helpers.types.myform:
        if (opts.configForm) {
          return (
            <MyForm
              inMyModal={this}
              configFromModal={opts}
              configForm={opts.configForm}
              fnList={{
                ...this._fnList,
                ...opts.fnList,
                ...opts.configForm.fnList,
              }}
            />
          )
        } else {
          logW("Missing configForm")
          return <div></div>
        }
    }
    return _ui
  }
  _renderBody = () => {
    const { opts } = this.state
    if (opts.usingModalBody === true) {
      return (
        <ModalBody className={opts.classNameBody || ""}>
          {this._renderContent()}
        </ModalBody>
      )
    }
    if (opts.wrapComponentBody) {
      let TagBody = opts.wrapComponentBody
      return <TagBody>{this._renderContent()}</TagBody>
    }
    return this._renderContent()
  }
  _renderHeaderContent = () => {
    const { opts } = this.state
    return opts.title
  }
  _renderHeader = () => {
    const { opts } = this.state
    if (opts.showHeader === true) {
      return (
        <ModalHeader toggle={this.toggle}>
          {this._renderHeaderContent()}
        </ModalHeader>
      )
    }
    return null
  }
  _renderFooter = () => {
    const { opts } = this.state
    if (opts.showFooter === true) {
      return (
        <ModalFooter>
          {opts.showFooterClose && (
            <Button
              color="secondary"
              onClick={() => {
                if (opts.onClickClose) {
                  opts.onClickClose(this)
                } else {
                  this.hide()
                }
              }}
            >
              Close
            </Button>
          )}
          {opts.showFooterOK && (
            <Button
              color={opts.colorBtnOK || "primary"}
              onClick={() => {
                if (opts.onClickOK) {
                  opts.onClickOK(this)
                }
              }}
            >
              {opts.titleBtnOK || "OK"}
            </Button>
          )}
        </ModalFooter>
      )
    }
    return null
  }
  _getClassname = () => {
    const { opts } = this.state
    return classnames(opts.modalClassName, {
      "modal-dialog-centered": opts.modalCentered,
      [`modal-${opts.size}`]: true, //sm,lg,xl,full,overscreen
      "modal-dialog-scrollable": opts.modalScrollInside,
    })
  }
  _renderOverlay = () => {
    if (this.state.showLoading === true) {
      return (
        <div className="a-overlay">
          <MyLoading />
        </div>
      )
    }
  }
  render() {
    const { isShow, opts } = this.state
    const { backdrop } = opts
    return (
      <Modal
        isOpen={isShow === true}
        fade
        backdrop={backdrop != null ? backdrop : true}
        toggle={this.toggle}
        className={this._getClassname()}
      >
        {this._renderHeader()}
        {this._renderBody()}
        {this._renderFooter()}
        {this._renderOverlay()}
      </Modal>
    )
  }
  static Helpers = {
    defaultConfigModal: {
      usingModalBody: true,
      showHeader: true,
      size: "lg",
    },
    types: {
      component: "component",
      myui: "myui",
      myform: "myform",
      mypage: "mypage",
      lightbox: "lightbox",
      mydialog: "mydialog",
      cellinmodal: "cellinmodal",
    },
    initComponent: (type, component) => {
      if (type && component) {
        MyModal.Helpers.components[type] = component
      }
    },
    components: {},
  }
  static showWithType = (type, opts) => {
    if (MyModal.Helpers.components[type]) {
      MyModal.Helpers.components[type].show(opts)
    }
  }
  static showFromMyUI = (configMyUI, configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.myui, {
      configMyUI: configMyUI,
      ...configModal,
    })
  }
  static showFromMyPage = (configMyPage, configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.mypage, {
      configMyPage: configMyPage,
      ...configModal,
    })
  }
  static showFromMyForm = (configForm, configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.myform, {
      configForm: configForm,
      backdrop: "static",
      ...configModal,
    })
  }
  static showFromComponent = (component, configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.component, {
      component: component,
      ...configModal,
    })
  }
  static showMyDialog = (configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.mydialog, {
      ...configModal,
    })
  }
  static showCellInModal = (
    propsCell: any,
    configModal: IConfigModal | null
  ) => {
    MyModal.showWithType(MyModal.Helpers.types.cellinmodal, {
      configMyUI: {
        type: "_wrapCellOnModal",
        ...propsCell,
      },
      size: "xl",
      showHeader: true,
      showFooter: false,
      ...configModal,
    })
  }
  static showConfirm = (configModal: IConfigModal | null) => {
    MyModal.showWithType(MyModal.Helpers.types.mydialog, {
      size: "xs",
      showFooter: true,
      showFooterOK: true,
      showFooterClose: true,
      backdrop: "static",
      component: () => {
        if (configModal?.msg) {
          return (
            <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
              {configModal?.msg}
            </div>
          )
        } else if (configModal?.msgHtml) {
          return (
            <div style={{ wordBreak: "break-word", whiteSpace: "pre-wrap" }}>
              <MyUI type="html" html={configModal?.msgHtml} />
            </div>
          )
        }
      },
      ...configModal,
    })
  }
  static hideModalComponent = () => {
    if (MyModal.Helpers.components[MyModal.Helpers.types.component]) {
      MyModal.Helpers.components[MyModal.Helpers.types.component].hide()
    }
  }
  static hideModalMyUI = () => {
    if (MyModal.Helpers.components[MyModal.Helpers.types.myui]) {
      MyModal.Helpers.components[MyModal.Helpers.types.myui].hide()
    }
  }
  static hideModal = type => {
    if (MyModal.Helpers.components[type]) {
      MyModal.Helpers.components[type].hide()
    }
  }
  static renderHeader = ({
    cModal,
    styleModalHeader,
    title,
  }: {
    cModal?: any
    styleModalHeader?: any
    title?: any
  } = {}) => {
    return (
      <ModalHeader
        toggle={() => {
          if (cModal && cModal.hide) {
            cModal.hide()
          }
        }}
        style={{
          padding: "0px",
          paddingBottom: "1rem",
          marginBottom: "1rem",
          ...styleModalHeader,
        }}
      >
        {typeof title === "function" ? title({}) : title}
      </ModalHeader>
    )
  }
}

export default MyModal
